const Number = {
  props: [
    {
      name: 'value',
      default: '',
      type: 'nunber',
      desc: '值，支持v-model'
    },
    {
      name: 'min',
      default: '',
      type: 'number',
      desc: '最小值'
    },
    {
      name: 'max',
      default: '',
      type: 'number',
      desc: '最大值'
    },
    {
      name: 'precision',
      default: '',
      type: 'number',
      desc: '精确位数'
    },
    {
      name: 'size',
      default: '',
      type: 'large | medium | small',
      desc: '尺寸'
    },
    {
      name: 'disabled',
      default: '',
      type: 'boolean',
      desc: '禁用'
    },
    {
      name: 'placeholder',
      default: '',
      type: 'string',
      desc: 'placeholder'
    },
    {
      name: 'unit',
      default: 'true',
      type: 'boolean',
      desc: '是否显示单位'
    }
  ],
  slots: [
    {
      name: 'prepend',
      desc: '前置内容'
    },
    {
      name: 'append',
      desc: '后置内容'
    }
  ]
}

export default [
  {
    name: 'Number API',
    content: Number
  }
]
